import { AdvancedSearchLoader } from '@pages/AdvancedSearchListCreatorPage/Loader';
import HomePage from '@pages/HomePage';
import ListDetailPage from '@pages/ListDetailPage';
import ListsPage from '@pages/ListsPage';
import NewListPage from '@pages/NewListPage';
import NotFound from '@pages/NotFound';
import { QuickSearchLoader } from '@pages/QuickFilterListCreatorPage/Loader';
import SavedSearchesPage from '@pages/SavedSearchesPage';
import { SearchTemplatePageLoader } from '@pages/SearchTemplatePage/Loader';
import SkeletonPage from '@pages/SkeletonPage';
import { DashboardPage } from '@pages/superset/dashboardTest';
import Token from '@pages/Token';
import { Route, Routes } from 'react-router';
import { environment, microfrontendURLPrefix, spaMode } from './config';
import { useFeatureToggle } from './featureToggles/FeatureTogglesContext';
import { useUserDetails } from './hooks';

export default function AppRoutes() {
  const enableDevFeatures = useFeatureToggle('Developer Features');
  const { data: userDetails, isPending: isUserDetailsPending } = useUserDetails();
  const isCoordinator = ['Coordinator', 'Principal Coordinator'].includes(
    userDetails?.userLevel ?? 'None'
  );
  const isPrincipalCoordinator = ['Principal Coordinator'].includes(
    userDetails?.userLevel ?? 'None'
  );

  const isNone = userDetails?.userLevel === 'None';

  return (
    <Routes>
      <Route path={spaMode === 'standalone' ? '/' : microfrontendURLPrefix}>
        <Route index element={<HomePage />} />
        <Route path="token" element={<Token />} />
        {isCoordinator && <Route path="searchlibrary" element={<SavedSearchesPage />} />}
        {isNone && <Route path="searchlibrary" element={<SkeletonPage />} />}

        {enableDevFeatures && <Route path="superset" element={<DashboardPage />}></Route>}

        <Route path="newlists">
          <Route path=":listId" element={<NewListPage />} />
        </Route>
        <Route path="lists">
          <Route index element={<ListsPage />} />
          <Route path=":listId">
            <Route index element={<ListDetailPage />} />
            <Route path=":tabSelection" element={<ListDetailPage />} />
          </Route>
        </Route>

        <Route path="quicksearch">
          {isCoordinator && <Route path=":searchId" element={<QuickSearchLoader />} />}
          {isNone && <Route path=":searchId" element={<SkeletonPage />} />}
          {isCoordinator && <Route index element={<QuickSearchLoader />} />}
          {isNone && <Route index element={<SkeletonPage />} />}
        </Route>

        <Route path="advancedsearch">
          {isCoordinator && <Route path=":searchId" element={<AdvancedSearchLoader />} />}
          {isNone && <Route path=":searchId" element={<SkeletonPage />} />}
          {isCoordinator && <Route index element={<AdvancedSearchLoader />} />}
          {isNone && <Route index element={<SkeletonPage />} />}
        </Route>

        <Route path="template">
          <Route
            path=":templateId/load"
            element={
              isUserDetailsPending ? (
                <SkeletonPage />
              ) : isCoordinator ? (
                <SavedSearchesPage />
              ) : (
                <NotFound />
              )
            }
          />
          {isPrincipalCoordinator && (
            <Route path=":searchTemplateId" element={<SearchTemplatePageLoader />} />
          )}
          {isPrincipalCoordinator && <Route index element={<SearchTemplatePageLoader />} />}
          {!isPrincipalCoordinator && <Route index element={<SkeletonPage />} />}
        </Route>

        {environment !== 'prod' && enableDevFeatures && (
          <>{/* Useful for pages to test experimental features on */}</>
        )}
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
